import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.css']
})
export class PackageComponent implements OnInit {



  Submitted: boolean = false;
  PackageList: any;
  PackageTypeList: any;
  dropdownSettings: any = {};
  selectedItems: any = [];
  constructor(private subcriptionService: SubscriptionService, private LookupService: LookupService,
     public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  PackageModel = {
    IsActive: true,
    PackageName: '',
    PackageTypeID: 0,
    PackageID: 0,
    PackageCost: 0,
    Description: '',    
    CountryIDs: '',   
    CountryArray: [],
    IsSMSPackage:false
  };

  ClearPackage() {
    this.Submitted = false;
    this.PackageModel.PackageName = '';
    this.PackageModel.PackageTypeID = 0;
    this.PackageModel.PackageCost = 0;
    this.PackageModel.PackageID = 0;
    this.PackageModel.Description='',    
    this.PackageModel.CountryIDs='',   
    this.PackageModel.CountryArray= [],
    this.PackageModel.IsSMSPackage=false

  };


  validation() {
    return this.PackageModel.PackageTypeID == 0;
  }


  PackageMarkActive(obj) {
    this.ClearPackage();
    this.PackageModel.PackageID = obj.PackageID;
    this.PackageModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.subcriptionService.PackageMarkActive(JSON.stringify(this.PackageModel)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.GetAllPackage();
      this.ClearPackage();
      this.globalHelper.CheckActionStatus(data);


    });
  }
  SavePackage(valid) {
    var CountryID = '';

    for (var i = 0; i < this.CountryList.length; i++) {
      for (var j = 0; j < this.PackageModel.CountryArray.length; j++) {
        if (this.PackageModel.CountryArray[j].ItemId == this.CountryList[i].ItemId && CountryID == '') {
          CountryID = this.CountryList[i].ItemId;
        }
        else if (this.PackageModel.CountryArray[j].ItemId == this.CountryList[i].ItemId) {
          CountryID = CountryID + "," + this.CountryList[i].ItemId;
        }
      }
    }
    this.PackageModel.CountryIDs = CountryID;
    this.Submitted = true;
    if (valid && !this.validation()) {
      this.spinnerService.show();
      this.subcriptionService.SavePackage(JSON.stringify(this.PackageModel)).subscribe((data: any) => {
        this.GetAllPackage();
        this.spinnerService.hide();

        this.ClearPackage();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  GetAllPackage() {
    this.subcriptionService.GetAllPackage(JSON.stringify(this.PackageModel)).subscribe((data: any) => {
      this.PackageList = data.PackageList;
    });

  }
  EditPackage(obj) {
    
    this.selectedItems = [];
    this.PackageModel.PackageID = obj.PackageID;
    var CountryIDs = obj.CountryIDs != null ? obj.CountryIDs.split(',') : '';
    for (var i = 0; i < this.CountryList.length; i++) {
      for (var j = 0; j < CountryIDs.length; j++) {
        if (CountryIDs[j] == this.CountryList[i].ItemId) {
          let item = {
            ItemId: this.CountryList[i].ItemId,
            ItemName: this.CountryList[i].ItemName

          }
          this.selectedItems.push(item)
          break;
        }
      }
    }
    this.PackageModel.PackageName = obj.PackageName;
    this.PackageModel.PackageTypeID = obj.PackageTypeID;
    this.PackageModel.PackageCost = obj.PackageCost;
    this.PackageModel.PackageID = obj.PackageID;
    this.PackageModel.Description=obj.Description,    
    this.PackageModel.CountryIDs=obj.CountryIDs,   
    this.PackageModel.CountryArray=this.selectedItems,
   
    this.PackageModel.IsSMSPackage=obj.IsSMSPackage
  };

  ngOnInit() {
    this.GetCountry();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 4,
      allowSearchFilter: false
    };
    this.GetAllPackageType();
    this.GetAllPackage();
  }


  GetAllPackageType() {

    this.LookupService.GetLookupsList('PackageType', '').subscribe((data: any) => {
      this.PackageTypeList = data.LookupItems;
    });
  }
  CountryList:any;
  GetCountry() {

    this.LookupService.GetLookupsList('Country', '').subscribe((data: any) => {
      this.CountryList = data.LookupItems;
    });
  }
}
